angular.module('dnecom')
    .controller('StoreKiboSettingsController', StoreKiboSettingsController);

StoreKiboSettingsController.$inject = ['$scope', '$http', 'notifications'];

function StoreKiboSettingsController($scope, $http, notifications) {
    let vm = this;
    const store = TemplateData.value('store');
    const props = _.get(store, ['properties', 'kibo']);
    let collections = [];
    let selectedCollectionId = null;
    vm.isKiboEnabled = false;
    vm.homepageCollectionsTitle = _.get(props, ['home_page_homepageCollectionsTitle'], '') || 'SHOP OUR COLLECTIONS BELOW';
    vm.needDisplayCollectionsTitle = false;
    vm.isKiboEnabled = store.template === 'kibo';

    vm.toggleKiboTemplate = function () {
        vm.isKiboEnabled = !vm.isKiboEnabled;
        $http.post(
            Routing.generate('stores_enable_kibo_template', { id: store.id}),
            {'template': vm.isKiboEnabled ? 'kibo' : null}
        )
    };

    vm.changeHomepageCollectionsTitle = () => {
        $http.post(
            Routing.generate('stores_update_settings', {id: store.id, group: 'KiboHomePage'}),
            {
                properties: {
                    kiboHomePage: {
                        homepageCollectionsTitle: vm.homepageCollectionsTitle
                    }
                }
            }
        ).catch(() => {
            notifications.danger("Error: could not change Home Page settings.");
        })
    };

    vm.checkTitleLength = () => {
        if (vm.homepageCollectionsTitle.length > 100) {
            vm.homepageCollectionsTitle = vm.homepageCollectionsTitle.substring(0, 100);
        }
    };

    $scope.$on(
        'store.collection.fetch-finish',
        (evt, data) => {
            collections = data;
            checkTitleSectionVisability();
        }
    );

    $scope.$on(
        'store.homepage-settings.collection.select',
        (evt, data) => {
            selectedcollectionId = data;
            checkTitleSectionVisability();
        }
    );

    function checkTitleSectionVisability() {
        vm.needDisplayCollectionsTitle = collections.length > 1 || (
            collections.length === 1 &&
            collections[0].id !== selectedCollectionId
        );
    }
}
